// Make planning mutations, spread into `mutations` in shared/mutations.ts. The plan itself needs none: it's worked
// out from synced tables (shared/planning.ts with BOMs, shared/make.ts). Draft POs from the plan use po.create
// (kind make for builds). Implementation: server/src/mutations/make.ts → server/src/auto-reorder.ts.
import { z } from "zod";
import { custom } from "./mutation-kit.ts";

export const makeMutations = {
  /** Auto mode now (it also runs nightly after the forecast): draft POs for items set to auto-reorder; never sends. */
  "plan.auto_reorder": custom(z.object({})),
} as const;
